
  import UndrawOnlineShopping from 'react-undraw/dist/illustrations/UndrawOnlineShopping';
    
  import UndrawConfirmation from 'react-undraw/dist/illustrations/UndrawConfirmation';
    
  const mappings = {
  
      'online-shopping' : UndrawOnlineShopping,
    
      'confirmation' : UndrawConfirmation,
    
  };
  
  export default mappings;
  